import React, { useState, useRef } from "react";
import { Box, Typography, Button } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import clientFetcher, { MediaResponse } from "src/lib/fetcher/client";
import { toast } from "react-toastify";

interface FileUploadBoxProps {
  title: string;
  width: any;
  height: any;
  onSubmit: (file: MediaResponse) => void;
}

const FileUploadBox: React.FC<FileUploadBoxProps> = ({ title, width, height, onSubmit }) => {
  const [file, setFile] = useState<File | null>(null);
  const [fileName, setFileName] = useState<string>("");
  const fileInputRef = useRef<HTMLInputElement | null>(null);

  const handleFileChange = (event: any) => {
    const selectedFile = event.target.files && event.target.files[0];
    if (selectedFile) {
      setFile(selectedFile);
      setFileName(selectedFile.name);
    }
  };

  const handleBoxClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleSubmit = async () => {
    if (!file) {
      alert("Hãy chọn 1 file.");
      return;
    }

    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await clientFetcher.uploadFile(file);
      onSubmit(response.value);
    } catch (error) {
      console.error("Error uploading file:", error);
    }
  };

  return (
    <>
      <Box
        width="100%" // Full width of parent
        padding={3}
        border="2px solid #ddd"
        borderRadius="8px"
        display="flex"
        flexDirection="column"
        gap={2}
        sx={{ cursor: "pointer" }} // Adds a pointer cursor
      >
        {/* Title */}
        <Typography variant="h6" component="h2">
          {title}
        </Typography>

        {/* Hidden File Input */}
        <input
          type="file"
          ref={fileInputRef} // Reference to trigger file input click
          style={{ display: "none" }}
          onChange={handleFileChange}
        />

        {/* File Upload Button */}
        <Button
          variant="outlined"
          component="span"
          onClick={handleBoxClick}
          startIcon={<CloudUploadIcon />}
          fullWidth
          style={{
            padding: "12px",
            justifyContent: "flex-start",
            color: "#555",
            borderColor: "#ddd",
          }}
        >
          {fileName || "Chọn file..."}
        </Button>

        {/* Title */}
        <Typography>Chiều rộng: {width}</Typography>

        <Typography>Chiều cao: {height}</Typography>

        {/* Submit Button on the Right */}
        <Box display="flex" justifyContent="flex-end">
          <Button variant="contained" color="primary" onClick={handleSubmit}>
            Xác nhận
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default FileUploadBox;
